import Button from "../components/ui/Button";
import { Phone, MessageCircle, MapPin } from "lucide-react";
import { useState, useEffect } from "react";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import app from "../firebase-config";
import { id_firebase } from "../content-site";
import { retiraMascara } from "../utils/retiraMascara";

const firestore = getFirestore(app);

export default function CTASection() {
    const [revenda, setRevenda] = useState({});
    const [telefone, setTelefone] = useState("");

    useEffect(() => {
        const fetchRevenda = async () => {
            try {
                const docRef = doc(firestore, "revenda", id_firebase);
                const docSnap = await getDoc(docRef);
                
                if (docSnap.exists()) {
                    setRevenda(docSnap.data());
                    setTelefone(retiraMascara(docSnap.data().petelefone2, "link"));
                }
            } catch (error) {
                console.error("Erro ao buscar dados da revenda:", error);
            }
        };

        fetchRevenda();
    }, []);

    return (
        <section className="py-24 bg-background relative overflow-hidden">
            <div className="absolute inset-0 bg-gradient-to-br from-primary/5 via-transparent to-transparent" />
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-primary/5 rounded-full blur-3xl" />

            <div className="container mx-auto px-6 relative z-10">
                <div className="max-w-4xl mx-auto text-center">
                    <span className="inline-block px-4 py-2 mb-6 text-sm font-semibold tracking-widest uppercase text-primary border border-primary/30 rounded-full">
                        Pronto para negociar?
                    </span>

                    <h2 className="text-display text-4xl md:text-5xl lg:text-6xl font-bold text-foreground mb-6">
                        Encontre o Caminhão <span className="text-primary">Ideal</span> Para Você
                    </h2>

                    <p className="text-lg md:text-xl text-muted-foreground mb-12 max-w-2xl mx-auto">
                        Nossa equipe está pronta para ajudar você a encontrar o veículo perfeito
                        para o seu negócio. Entre em contato agora mesmo!
                    </p>

                    <div className="flex flex-col sm:flex-row gap-4 justify-center mb-16">
                        <Button variant="hero" size="xl">
                            <Phone className="mr-2 h-5 w-5" />
                            {revenda.petelefone1}
                        </Button>
                        <Button variant="heroOutline" size="xl" href={`https://api.whatsapp.com/send?phone=55${telefone}`}>
                            <MessageCircle className="mr-2 h-5 w-5" />
                            WhatsApp
                        </Button>
                    </div>

                    <div className="grid md:grid-cols-3 gap-6">
                        <div className="p-6 bg-card rounded-lg border border-border/50 card-shadow hover:border-primary/50 transition-all duration-300">
                            <Phone className="w-8 h-8 text-primary mx-auto mb-4" />
                            <h4 className="font-bold text-foreground mb-2">Telefone</h4>
                            <p className="text-muted-foreground">{revenda.petelefone1}</p>
                        </div>
                        <div className="p-6 bg-card rounded-lg border border-border/50 card-shadow hover:border-primary/50 transition-all duration-300">
                            <MessageCircle className="w-8 h-8 text-primary mx-auto mb-4" />
                            <h4 className="font-bold text-foreground mb-2">WhatsApp</h4>
                            <p className="text-muted-foreground">{revenda.petelefone2}</p>
                        </div>
                        <div className="p-6 bg-card rounded-lg border border-border/50 card-shadow hover:border-primary/50 transition-all duration-300">
                            <MapPin className="w-8 h-8 text-primary mx-auto mb-4" />
                            <h4 className="font-bold text-foreground mb-2">Endereço</h4>
                            <p className="text-muted-foreground">
                                {revenda.peendereco_fiscal && `${revenda.peendereco_fiscal}, ${revenda.peendereco_fiscal_numero || ''} – ${revenda.pebairro_fiscal || ''}`}
                                {revenda.pecidade && ` - ${revenda.pecidade}`}
                                {revenda.peuf && ` - ${revenda.peuf}`}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}